import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { requireMenuOrRedirect } from '@/lib/auth/require-permission';

const UsersPage = lazy(() =>
  import('@/pages/ads/users/users-page').then((m) => ({ default: m.UsersPage })),
);

export const Route = createFileRoute('/_app/ads/users')({
  beforeLoad: requireMenuOrRedirect('menu:ads-admin:users', '/ads/accounts'),
  component: () => (
    <Suspense fallback={<div>加载中…</div>}>
      <UsersPage />
    </Suspense>
  ),
});
